export default __webpack_public_path__ + "static/media/insurance-empty-box.5f22f24a.png";